import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5d1871b1&scoped=true&"
import script from "./company.vue?vue&type=script&lang=ts&"
export * from "./company.vue?vue&type=script&lang=ts&"
import style0 from "./company.vue?vue&type=style&index=0&id=5d1871b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1871b1",
  null
  
)

export default component.exports